import { render, staticRenderFns } from "./bulkyOrder.vue?vue&type=template&id=13de1e6a&scoped=true&"
import script from "./bulkyOrder.vue?vue&type=script&lang=js&"
export * from "./bulkyOrder.vue?vue&type=script&lang=js&"
import style0 from "./bulkyOrder.vue?vue&type=style&index=0&id=13de1e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de1e6a",
  null
  
)

export default component.exports